import { error } from '@/services/Log'
import { StandardCart } from '@/types/ShopFront/CheckoutStandards'
import { toShippingProtectionSKU } from '@/helpers/toShippingProtectionSKU'
import { rawCartAddCustomItem } from './rawCartAddCustomItem'

export const rawAddWarranty = async (cart: StandardCart) => {
  try {
    if (!cart.warrantyOfferId) {
      throw new Error('No warranty offer ID found')
    }
    await rawCartAddCustomItem({
      cartId: cart.id,
      quoteIds: cart.warrantyOfferId.map((item) => item.quoteId),
      items: cart.warrantyOfferId.map((item) => ({
        name: `Worry Free Delivery-${item.sku}`,
        sku: (
          toShippingProtectionSKU({
            offerId: item.quoteId,
            items: [{
              sku: item.sku,
              quantity: item.quantity,
              price: item.skuPrice,
            }],
          })
        ),
        quantity: 1,
        price: item.quotePrice,
      })),
    })

    return {
      success: true,
    }
  } catch (err) {
    error('Failed to remove the item from the cart')
  }
  return { success: false }
}

export default rawAddWarranty
